<template>


  <!-- <div class="login-layout md-layout md-gutter md-alignment-top-left" style="overflow: hidden"> -->
  <div style="overflow: hidden">
  <remote-check-in-form ref="RemoteCheckInForm" mode="UPDATE"/>

    <!-- <div class="md-layout-item md-size-0"></div> -->
    <div class="md-layout-item md-size-0" style="overflow: hidden">
      <form style="overflow: hidden" novalidate v-if="newPasswordForm.active" @submit.prevent="doSetNewPassword">
        <md-card-header>
          <div class="md-title">New password required</div>
        </md-card-header>
        <md-card-content>
          <md-field :class="getValidationClass('newPasswordForm.password')">
            <label for="password">New password</label>
            <md-input name="password" id="newPassword" type="password" autocomplete="new-password" v-model="newPasswordForm.password" :disabled="sending"/>
            <span class="md-error" v-if="!$v.newPasswordForm.password.required">Password is required</span>
            <span class="md-error" v-else-if="!$v.newPasswordForm.password.minlength">Invalid password</span>
          </md-field>
        </md-card-content>

        <md-progress-bar md-mode="indeterminate" v-if="sending"/>

        <md-card-actions>
          <md-button type="submit" class="md-primary" :disabled="sending">Save</md-button>
        </md-card-actions>
      </form>


      <form style="overflow: hidden" novalidate v-else @submit.prevent="doLogin">
        <md-card style="overflow: hidden" class="md-layout-item md-size-100">
          <div style="height: 30px"></div>
            <div class ="gcontainer">

                <div class = "item1">Remote Check-In
                  <h1 class = "Statements">We have frequently updated our web check-in portal. Please close your browser once you finish check-in, to apply the most updated function. </h1>
                  <md-card-content>
                    <md-field :class="getValidationClass('searchRequest.ibs')">
                      <label for="ibs">IBS Number</label>
                      <md-input v-model.trim="searchRequest.ibs"/>
                    </md-field>
    
                    <md-field :class="getValidationClass('searchRequest.apptNo')">
                      <label for="apptNo">Appointment Number</label>
                      <md-input v-model.trim="searchRequest.apptNo"/>
                    </md-field>

                    <md-field class="md-hide">
                      <label>Group</label>
                      <md-select v-model="loginForm.userPool" name="user-pool" id="user-pool">
                        <md-option value="acni">ACNI</md-option>
                      </md-select>
                    </md-field>
                  </md-card-content>

                  <md-progress-bar md-mode="indeterminate" v-if="sending"/>

                  <b-notification class = "notifySize"
                                    type="is-success"
                                    v-model="notifyActive"
                                    aria-close-label="Close notification">
                                    {{notifyMessage}}
                  </b-notification>

                  <h1 class = "Statements">***** MUST READ *****</h1>
                  <h1 class = "Statements">*Do not come to the warehouse until you are called to scale.</h1>
                  <h1 class = "Statements">*Do not double park and block the roads while you await our call. </h1>
                  <h1 class = "Statements">*Find legal parking in the area.</h1>
                  <h1 class = "Statements">*Long Beach Police Department will take enforcement action against illegal parking.</h1>


                  <md-card-actions>
                    <calling-api :paths="['/api/w/users/me']">
                      <md-button class="md-primary" @click="doCheckin">Check-In</md-button>
                    </calling-api>
                  </md-card-actions>
                </div>


                <div class = "item1">FSI Login
                  <md-card-content>
                    <md-field :class="getValidationClass('loginForm.username')">
                      <label for="username">Username</label>
                      <md-input name="username" id="username" autocomplete="new-password" v-model="loginForm.username" :disabled="sending"/>
                      <span class="md-error" v-if="!$v.loginForm.username.required">Username is required</span>
                      <span class="md-error" v-else-if="!$v.loginForm.username.minLength">Invalid username</span>
                    </md-field>
                    <md-field :class="getValidationClass('loginForm.password')">
                      <label for="password">Password</label>
                      <md-input name="password" id="password" type="password" autocomplete="new-password" v-model="loginForm.password" :disabled="sending"/>
                      <span class="md-error" v-if="!$v.loginForm.password.required">Password is required</span>
                      <span class="md-error" v-else-if="!$v.loginForm.password.minLength">Invalid password</span>
                    </md-field>
                    <md-field class="md-hide">
                      <label>Group</label>
                      <md-select v-model="loginForm.userPool" name="user-pool" id="user-pool">
                        <md-option value="acni">ACNI</md-option>
                      </md-select>
                    </md-field>
                  </md-card-content>

                  <md-progress-bar md-mode="indeterminate" v-if="sending"/>

                  <md-card-actions>
                    <calling-api :paths="['/api/w/users/me/device','/api/w/users/me']">
                      <md-button type="submit" class="md-primary" :disabled="sending">Login</md-button>
                    </calling-api>
                  </md-card-actions>

                  <div>
                    <a href="mailto:ERPIT@acni.net">Contact ACN</a>
                  </div>
                </div>
              </div>
        </md-card>

        <md-snackbar :md-active.sync="hasError" :md-duration="Infinity" :md-persistent="true">
          <template v-if="err">{{err.message}}</template>
        </md-snackbar>
      </form>
  
    </div>
 
    <div class="md-layout-item md-size-25"></div>
  </div>
</template>

<script>
  import { validationMixin } from 'vuelidate'
  import Amplify, { Auth } from 'aws-amplify';
  import Config from '../config';
  //import api from '../api';
  import { newAPIPost } from '../api';
  import awsmobile from '../aws-exports';
  import { mapGetters } from 'vuex';
  import callingApiCenter from "../components/CallingApiCenter.vue";
  import RemoteCheckInForm from '../components/RemoteCheckInForm.vue';

  import {
    required,
    email,
    minLength,
    maxLength
  } from 'vuelidate/lib/validators'


  const getInitSearch = () => ({
    ibs_types: [],
    ibs : null,
    receivingWindows : null,
    checkIn : null,
    username : null,
    inboundSeq : null,
    inboundStatus : null,
    block : null,
    apptNo : null,
    apptDate : null,
    externalTrucker : null,

  });


  export default {
    mixins: [validationMixin],
    data: () => ({
      searchRequest: getInitSearch(),
      ibsinbound: [],
      loginForm: {
        username: null,
        password: null,
        userPool: 'acni',
      },
      newPasswordForm: {
        active: false,
        password: null,
        cognitoUser: null,
      },
      hasError: false,
      err: null,
      sending: false,
      awsConfig: null,
      appLinks: Config.appLinks,
      notifyActive: false,
      notifyMessage: " ",
    }),

    components: {
      RemoteCheckInForm,
      callingApiCenter,
    },

    watch: {
    
    },

    computed: {
    ...mapGetters([
        'getibsInbound',
      ]),
    },

    validations: {
      loginForm: {
        username: {
          required,
          minLength: minLength(3)
        },
        password: {
          required,
          minLength: minLength(8)
        },
      },
      newPasswordForm: {
        password: {
          required,
          minLength: minLength(8)
        },
      }
    },
    methods: {
      getValidationClass(fieldName) {
        const field = _(this.$v).lookup(fieldName)

        if (field) {
          return {
            'md-invalid': field.$invalid && field.$dirty
          }
        }
      },
      doLogin() {
        this.$v.loginForm.$touch();

        if (this.loginForm.username == "REMOTECHECKIN") {
          return;
        }

        if (this.$v.loginForm.$invalid) {
          return;
        }

        this.awsConfig = Config.awsConfigs[this.loginForm.userPool];
        console.log(`awsConfig=${JSON.stringify(this.awsConfig)}`);
        const mergedConfig = _(awsmobile).extend(this.awsConfig);
        console.log(`mergedConfig`, mergedConfig);
        Amplify.configure(mergedConfig);

        this.sending = true;
        this.hasError = false;

        Auth.signIn(this.loginForm.username, this.loginForm.password).then(cognitoUser => {
          this.sending = false;
          console.log(cognitoUser);

          if (cognitoUser.challengeName === "NEW_PASSWORD_REQUIRED") {
            this.newPasswordForm.active = true;
            this.newPasswordForm.cognitoUser = cognitoUser
          } else {
            this.handleLoggedIn();
          }

        }).catch(err => {
          console.log(err);
          this.sending = false;
          this.hasError = true;
          this.err = err;
        });
      },

      doSetNewPassword() {
        this.$v.newPasswordForm.$touch();

        if (this.$v.newPasswordForm.$invalid) {
          return;
        }

        this.sending = true;
        this.hasError = false;

        Auth.completeNewPassword(this.newPasswordForm.cognitoUser, this.newPasswordForm.password, {})
          .then(res => {
            this.sending = false;
            this.handleLoggedIn();
          })
          .catch(err => {
            console.log(err);
            this.sending = false;
            this.hasError = true;
            this.err = err;
          });
      },

      handleLoggedIn() {
        Auth.currentAuthenticatedUser().then((cognitoUser) => {
          cognitoUser.getCachedDeviceKeyAndPassword();
          const { deviceKey } = cognitoUser;

          const saveDeviceAndLogin = () => {
            localStorage.setItem("deviceKey", deviceKey);
            //api.post('/api/w/users/me/device', {}).then(() => {
            newAPIPost('/api/w/users/me/device', {}).then(() => {  
              this.$store.dispatch(
                'userLoggedIn',
                {
                  awsConfig: this.awsConfig
                }
              );
            });
          };
          
          //api.post('/api/w/users/me', {}).then((userProfile) => {
          newAPIPost('/api/w/users/me', {}).then((userProfile) => {  
            console.log(`current deviceKey = ${deviceKey}`);
            console.log(`userProfile deviceKey = ${userProfile.currentDeviceKey}`);
            if (!!userProfile.currentDeviceKey && userProfile.currentDeviceKey != deviceKey) {
              if (window.confirm("There's another logged in session, do you want to kick the logged in session and login?")) {
                saveDeviceAndLogin();
              } else {
                this.$store.dispatch('logout');
              }
            } else {
              saveDeviceAndLogin();
            }
          });
        });
      },


      async doCheckin() {

        if (this.searchRequest.ibs == null) {
          return;
        }
 
        this.loginForm.username = "XXXXXXX"
        this.loginForm.password = "XXXXXXX" 
 
        this.awsConfig = Config.awsConfigs[this.loginForm.userPool];
        console.log(`awsConfig=${JSON.stringify(this.awsConfig)}`);
        const mergedConfig = _(awsmobile).extend(this.awsConfig);
        console.log(`mergedConfig`, mergedConfig);
        Amplify.configure(mergedConfig);

        this.sending = true;
        this.hasError = false;

        Auth.signIn('REMOTECHECKIN', '123123123').then(cognitoUser => {
          this.sending = false;
          console.log(cognitoUser);

          if (cognitoUser.challengeName === "NEW_PASSWORD_REQUIRED") {
            this.newPasswordForm.active = true;
            this.newPasswordForm.cognitoUser = cognitoUser
          } else {
            this.handleCheckIn();
          }

        }).catch(err => {
          console.log(err);
          this.sending = false;
          this.hasError = true;
          this.err = err;
        });
      },

      async handleCheckIn() {
          this.notifyActive = false
          this.notifyMessage = " "

          //api.post('/api/w/users/me', {}).then((userProfile) => {
          newAPIPost('/api/w/users/me', {}).then((userProfile) => {  
            console.log(`userProfile  = ${userProfile}`);     
          });

          
          this.searchRequest.inboundStatus = "O"
          const search = this.searchRequest;
          //const result = await api.post('/api/w/fsi/GetIBSInbound', search);
          const result = await newAPIPost('/api/w/fsi/GetIBSInbound', search);
          const request = result[0];
          
          var appN = search.apptNo;
          var APPN = appN.toUpperCase();

          if ( request == undefined){
            this.searchRequest.inboundStatus = "C"
            //const result = await api.post('/api/w/fsi/GetIBSInbound', search);
            const result = await newAPIPost('/api/w/fsi/GetIBSInbound', search);
            const request = result[0];
            if ( request == undefined){
              this.notifyActive = true
              this.notifyMessage = "IBS/Appointment Number not match!!" 
            }
            else{
              if ( APPN == request.apptNo ){
                this.$refs.RemoteCheckInForm.openDialog(request);
              }
              else{
                this.notifyActive = true
                this.notifyMessage = "IBS/Appointment Number not match!!" 
              }
            }
          }
          else{
            if ( APPN == request.apptNo ){
            this.$refs.RemoteCheckInForm.openDialog(request);
            }
            else{
              this.notifyActive = true
              this.notifyMessage = "IBS/Appointment Number not match!!" 
            }
          } 
      },
    }
  };


</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .login-layout {
    height: 100vh;
  }

  form {
    background: white;
  }

.notifySize{
  color: red;
  background-color: yellow;
}

.gcontainer {
  display: grid;
  grid-template-columns: 1fr;
  text-align: center;
  background-color: #adacfc;
  
}

.gcontainer div {
  margin: 5px;
  /* width: 350px; */
  text-align: center;
  line-height: 25px;
  font-size: 25px;
  color: rgb(0, 17, 248);
  background-color:rgb(213, 238, 228);
}

.Statements {
    padding-top: 0px;
    padding-left: 0px;
    margin-bottom: 0;
    color: rgb(255, 0, 0);
    width: 100%;
    font-size: 16px;
    font-family: Roboto Slab;
    margin: 0;
    text-align: left;
  }
</style>
